import React from "react";
// import { CheckOutlined } from "@ant-design/icons";
import { Select } from "antd";

const SelectSingle = _props => {
  const {
    type,
    options,
    value,
    noAllowClear,
    config,
    placeholder,
    handleScroll,
    handleSearch,
    disabled,
    loading,
    defaultValue,
    onChange = () => {},
  } = _props;

  const filterOption = (input, option) => {
    return (
      (option?.children?.props?.title ?? "")
        .toLowerCase()
        .includes(input.toLowerCase()) ||
      (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
      (option?.value ?? "").toLowerCase().includes(input.toLowerCase()) ||
      (option?.key ?? "").toLowerCase().includes(input.replace("04", "614"))
    );
  };

  return (
    <Select
      showSearch={type === "select-search"}
      allowClear={!noAllowClear}
      value={value}
      defaultValue={defaultValue ? defaultValue : null}
      onChange={value => {
        onChange && onChange(value);
      }}
      onSearch={handleSearch}
      onPopupScroll={handleScroll}
      placeholder={placeholder}
      disabled={disabled}
      filterOption={filterOption}
      loading={loading}
      style={{
        width: config?.width,
        padding: "0",
        textAlign: "start",
      }}
    >
      {options.map(option => (
        <Select.Option
          key={option.label + option.key}
          value={option.key}
          disabled={option.disabled}
        >
          {/* <Tooltip title={option.label}>{option.label}</Tooltip> */}
          <span>{option.label}</span>
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectSingle;
